import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Dealer } from '../models/dealer';
import { environment } from 'src/environments/environment';
import { WorkOrderSettings } from '../../../features/workorder/components/createworkorder/models/work-order-settings.model';
import { Observable } from 'rxjs';

export interface DealerResponse {
  data: Array<Dealer>;
  error: Array<string>;
}

export interface WorkOrderSettingsResponse {
  data: WorkOrderSettings;
  error: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class RestDealerService {
  private httpClient: HttpClient;
  private handler = inject(HttpBackend);
  private http = inject(HttpClient);

  constructor() {
    this.httpClient = new HttpClient(this.handler);
  }

  getAllDealers() {
    const url = environment.backOfficeUrl + environment.serviceUris.dealers;
    return this.httpClient.get<DealerResponse>(url);
  }

  /**
   * Get work order settings for UI field control and default status calculation.
   * This returns zone and dealer-level configuration flags including work order status logic.
   * Uses regular HttpClient to include authentication headers via interceptor.
   *
   * @param dealerId The dealer ID
   * @returns Observable<WorkOrderSettings> - UI control flags, settings, and default status
   */
  getWorkOrderSettings(dealerId: string): Observable<WorkOrderSettingsResponse> {
    const url = `${environment.backOfficeUrl}v1/dealers/${dealerId}/getWorkOrderSettings`;
    return this.http.get<WorkOrderSettingsResponse>(url);
  }
}
